import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.blue.light25,
    paddingTop: theme.spacing(8),
  },
  headline: {
    color: theme.palette.secondary.light,
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
  subtitle: {
    marginBottom: theme.spacing(5),
  },
  categoryTagsRow: {
    display: 'flex',
    gap: '0.625rem',
    marginBottom: theme.spacing(5),
    [theme.breakpoints.down('xs')]: {
      'overflow-x': 'scroll',
    },
  },
  categoryTags: {
    ...theme.typography.formTags,
    width: '135px',
    height: '45px',
    textAlign: 'center',
    borderRadius: '8px',
    whiteSpace: 'nowrap',
    fontSize: '14px',
    transition: '250ms',
    backgroundColor: 'white',
    color: theme.palette.secondary.main,
    textDecoration: 'none',
    '&:focus': {
      outline: '2px solid black',
    },
    [theme.breakpoints.down('xs')]: {
      ...theme.typography.formLabel,
      flexShrink: '0',
      fontSize: '12px',
      width: '110px',
    },
    '&:hover, &:active': {
      textDecoration: 'none',
      backgroundColor: theme.palette.blue.main,
      color: theme.palette.offwhite.main,
    },
  },
  active: {
    backgroundColor: theme.palette.blue.main,
    color: theme.palette.offwhite.main,
  },
  divider: {
    width: '100%',
    opacity: '0.5',
    height: '1px',
    backgroundColor: theme.palette.grey.light,
  },
  sliderContainer: {
    paddingBottom: theme.spacing(8),
    [theme.breakpoints.down('xs')]: {
      paddingBottom: theme.spacing(4),
    },
  },
  slider: {
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(4),
  },
  noResultsTitle: {
    color: theme.palette.secondary.light,
  },
  noResultsContainer: {
    height: '300px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      height: '250px',
    },
  },
  noResultsBody: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3),
  },
}))

export default useStyles
